// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class TalkingPointsService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getTalkingPointsList(params) {
        const url = this.urlsService.TALKING_POINTS.LIST;
        return this.ajaxService.getDataObserveBody(url, params);
    }
    /**
     * Fetches unpaginated talking points.
     */
    getTalkingPointsModalList(params) {
        const url = this.urlsService.TALKING_POINTS.LIST_MODAL;
        return this.ajaxService.getDataObserveBody(url, params);
    }
    postTalkingPoint(params) {
        const url = this.urlsService.TALKING_POINTS.COLLECTION;
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    putTalkingPoint(talkingPointId, params) {
        const url = this.urlsService.getUrl(this.urlsService.TALKING_POINTS.TALKING_POINT, {
            talkingPointId,
        });
        return this.ajaxService.putJsonDataObserveBody(url, params);
    }
    duplicateTalkingPoint(talkingPointId, newName, targetFolder) {
        const url = this.urlsService.getUrl(this.urlsService.TALKING_POINTS.DUPLICATE, { talkingPointId });
        const postParams = { name: newName, targetFolder };
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    deleteTalkingPoint(talkingPointId) {
        const url = this.urlsService.getUrl(this.urlsService.TALKING_POINTS.TALKING_POINT, {
            talkingPointId,
        });
        return this.ajaxService.deleteDataObserveBody(url);
    }
    getValidTemplateTypes(metric) {
        return this.ajaxService.getDataObserveBody(this.urlsService.TALKING_POINTS.VALID_TEMPLATE_TYPES, { metric });
    }
}
TalkingPointsService.ɵfac = function TalkingPointsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointsService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
TalkingPointsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TalkingPointsService, factory: TalkingPointsService.ɵfac, providedIn: 'root' });
